import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitConsultation = (data) =>
  axios.post(`${API}/enquiries/consultation`, data).then((r) => r.data);

export const submitQuote = (data) =>
  axios.post(`${API}/enquiries/quote`, data).then((r) => r.data);
